<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="11.951" height="6.697" viewBox="0 0 11.951 6.697">
		<path
			id="Path_2"
			data-name="Path 2"
			d="M0,0,4.562,4.283,9.124,0"
			transform="translate(1.413 1.414)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-miterlimit="10"
			stroke-width="2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'DropdownArrowSvg',
};
</script>
